import { useEffect, useRef, useState } from 'react'
import { FiCopy } from 'react-icons/fi'
import { RiCheckLine } from 'react-icons/ri'

/**
 * Copy-to-clipboard icon button for read-only values (DEV-2407). Shows a
 * check mark for 2s after copying.
 */
export const CopyButton = ({ value }: { value: string }) => {
	const [copied, setCopied] = useState(false)
	const timeoutRef = useRef<ReturnType<typeof setTimeout>>()

	useEffect(() => () => clearTimeout(timeoutRef.current), [])

	const handleCopy = () => {
		navigator.clipboard.writeText(value)
		setCopied(true)
		clearTimeout(timeoutRef.current)
		timeoutRef.current = setTimeout(() => setCopied(false), 2000)
	}

	return (
		<div className="relative h-[16px] w-[16px]">
			<button
				type="button"
				onClick={handleCopy}
				className="cursor-pointer absolute right-1"
				title="Copy to clipboard"
			>
				{copied ? (
					<RiCheckLine className="w-[16px] h-[16px] text-[#0B9055]" />
				) : (
					<FiCopy className="w-[16px] h-[16px] text-[#9F9EA3] hover:text-brand" />
				)}
			</button>
		</div>
	)
}
